// extracted by mini-css-extract-plugin
export default {"container":"NavList_container__xOJhK","roll-in-right":"NavList_roll-in-right__Hp5rk","links":"NavList_links__wDGfr"};